import { uiText, useUiLanguage } from '../../utils/uiTranslation';
import React from 'react';

/**
 * GeneratingAssessmentModal
 * 
 * Displayed when generating job-specific assessment questions for a newly added job
 * that doesn't have questions yet. Blocks candidate drop until generation completes.
 */
const GeneratingAssessmentModal = ({ isOpen, jobTitle, onClose }) => {
  useUiLanguage();
    if (!isOpen) return null;

    return (
        <div data-light-backdrop style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            backdropFilter: 'blur(4px)'
        }}>
            <div style={{
                backgroundColor: 'var(--app-surface, #0a1628)',
                borderRadius: '16px',
                border: "1px solid var(--app-border-strong, rgba(86, 141, 237, 0.3))",
                padding: '40px 50px',
                maxWidth: '450px',
                textAlign: 'center',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)'
            }}>
                {/* Animated Icon */}
                <div style={{
                    width: '80px',
                    height: '80px',
                    margin: '0 auto 24px',
                    backgroundColor: 'var(--app-surface, rgba(86, 141, 237, 0.15))',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: "2px solid var(--app-border-strong, rgba(86, 141, 237, 0.3))"
                }}>
                    <i
                        className="fa-solid fa-robot"
                        style={{
                            fontSize: '32px',
                            color: '#568ded',
                            animation: 'pulse 1.5s ease-in-out infinite'
                        }}
                    ></i>
                </div>

                <h3 style={{
                    fontFamily: 'Montserrat',
                    fontSize: '20px',
                    fontWeight: 600,
                    color: 'var(--app-text, #fff)',
                    margin: '0 0 12px'
                }}>{uiText("Generating Assessment")}</h3>

                <p style={{
                    fontFamily: 'Montserrat',
                    fontSize: '14px',
                    color: 'rgba(var(--app-ink-rgb, 255, 255, 255), 0.7)',
                    margin: '0 0 24px',
                    lineHeight: '1.6'
                }}>{uiText("Creating tailored questions for")}{' '}
                    <span style={{ color: '#568ded', fontWeight: 500 }}>
                        {jobTitle || uiText("this job")}
                    </span>
                    ...
                </p>

                {/* Loading Animation */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '8px',
                    marginBottom: '24px'
                }}>
                    {[0, 1, 2].map((i) => (
                        <div
                            key={i}
                            style={{
                                width: '10px',
                                height: '10px',
                                backgroundColor: '#568ded',
                                borderRadius: '50%',
                                animation: `bounce 1.4s ease-in-out ${i * 0.16}s infinite both`
                            }}
                        />
                    ))}
                </div>

                <p style={{
                    fontFamily: 'Montserrat',
                    fontSize: '12px',
                    color: 'rgba(var(--app-ink-rgb, 255, 255, 255), 0.5)',
                    margin: 0
                }}>{uiText("You'll be redirected to review the questions shortly")}</p>

                {/* CSS Animations */}
                <style>
                    {`
            @keyframes pulse {
              0%, 100% { opacity: 1; transform: scale(1); }
              50% { opacity: 0.7; transform: scale(1.05); }
            }
            @keyframes bounce {
              0%, 80%, 100% { transform: scale(0); }
              40% { transform: scale(1); }
            }
          `}
                </style>
            </div>
        </div>
    );
};

export default GeneratingAssessmentModal;
